import SectionPlaceholder from "./SectionPlaceholder";

export default SectionPlaceholder;
export { SectionPlaceholder };
